// src/common/layouts/AuthLayout.tsx
import React from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';


const { Content } = Layout;

const AuthLayoutWrapper = styled(Layout)`
  // min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: #f0f2f5; /* Light gray background */
`;

const AuthContent = styled(Content)`
  width: 100%;
  text-align: center;
`;

type AuthLayoutProps = {
  children: React.ReactNode;
};

function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <Layout style={{ minHeight: '100vh'}}>
    <AuthLayoutWrapper>
      <AuthContent>
        

          {children}
       
      </AuthContent>
    </AuthLayoutWrapper>
    </Layout>
  );
}

export default AuthLayout;